// extracted by mini-css-extract-plugin
export var button = "_lw-0";
export var donut = "_lw-1";
export var donutFill = "_lw-3";
export var donutTrack = "_lw-2";